export async function loadAsyncPolyfill(): Promise<void> {
  // Polyfill for react-three-fiber which is using use-react-measure (should be handled by the package itself)
  if (typeof window !== 'undefined' && !('ResizeObserver' in window)) {
    // Loads polyfill asynchronously, only if required.
    const importedModule = await import('@juggle/resize-observer');
    // @ts-ignore
    window.ResizeObserver = importedModule.ResizeObserver;
  }
}
